// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Summary_wrapper__25AqS","greenBackground":"Summary_greenBackground__1gGCf","orderTable":"Summary_orderTable__296Dt","topShadow":"Summary_topShadow__3bGTN"};